@if ($configSchema() != null) {
    <div class="form-group mt-4">
        <h5>Configurações do E-Docs</h5>
        <hr class="mt-0 mb-4" />
    </div>

    <div class="form-group mt-4 mb-2">
        <h6 class="d-inline-block">Destinatário</h6>
    </div>

    <!-- Seletor de destinatário -->
    <div featureHint="flowObjectDetails|DispatchProcessRecipientMode" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right">
        <mat-radio-group class="recipient-mode mb-2" id="recipientMode" name="recipientMode" color="primary"
                         [ngModel]="$recipientMode()"
                         [required]="true"
                         (ngModelChange)="recipientModeChange($event)"
        >
            <mat-radio-button [value]="RecipientMode.PublicAgent">Servidor</mat-radio-button>
            <mat-radio-button [value]="RecipientMode.OwnerImmediateSupervisor">Gestor imediato do solicitante do Fluxo</mat-radio-button>
            <mat-radio-button [value]="RecipientMode.OwnerHeadOfOrganization">Gestor máximo do órgão do solicitante do Fluxo</mat-radio-button>
            <mat-radio-button [value]="RecipientMode.Fixed">Local do E-Docs fixo</mat-radio-button>
            <mat-radio-button [value]="RecipientMode.Conditional">Local do E-Docs condicional</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- Servidor -->
    @if ($recipientMode() == RecipientMode.PublicAgent) {
        <!-- CPF do Servidor -->
        <div class="form-group dispatch-recipient ml-3px" featureHint="flowObjectDetails|RegisterProcessStakeholdersPublicAgentCpf" featureHintHAlign="right">
            <label for="servidorCpf">CPF do Servidor</label>
            <input type="text" class="form-control two-buttons" id="servidorCpf" name="servidorCpf"
                   placeholder="Entre com o CPF do servidor para filtrar seus papéis"
                   maxlength="11"
                   pattern="[0-9]{11}"
                   [ngModel]="$servidorCpf()"
                   (change)="$servidorCpf.set($event.target.value)"
                   (keyup.enter)="searchServidorCpf()"
            >
            <i class="fas fa-search action search ml-2" matTooltip="Procurar" (click)="searchServidorCpf()" (keyDown)="searchServidorCpf()"></i>
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearServidorCpf()" (keyDown)="clearServidorCpf()"></i>
        </div>

        <!-- Papéis do Servidor -->
        <div class="form-group dispatch-recipient ml-4" featureHint="flowObjectDetails|RegisterProcessStakeholdersPublicAgentRole" featureHintHAlign="right">
            <label for="servidorPapelDisplay">Papéis do Servidor</label>
            <input type="text" class="form-control info-font two-buttons" id="servidorPapelDisplay"
                   name="servidorPapelDisplay"
                   placeholder="Selecione um papel do servidor"
                   [ngModel]="$servidorPapelDisplay()"
                   [matTooltip]="$servidorPapelNome()"
                   [matAutocomplete]="servidorPapelAutocompleteProcessStakeholders"
                   [disabled]="$servidorPapeis().length == 0"
                   (ngModelChange)="$servidorPapelDisplay.set($event)"
                   (input)="servidorPapelDisplayChange()"
            >
            <mat-autocomplete #servidorPapelAutocompleteProcessStakeholders="matAutocomplete"
                              [displayWith]="displayServidorPapelId"
                              (optionSelected)="servidorPapelIdChange($event)"
            >
                @for (option of $selectableServidorPapeis(); track option) {
                    <mat-option [value]="option">
                        <span class="uppercase">
                            {{option.nome}} - {{option.lotacao.nomeCurto}} - {{option.lotacao.organizacao.sigla}} - {{option.lotacao.organizacao.organizacaoPai.sigla}}
                        </span>
                    </mat-option>
                }
            </mat-autocomplete>
            <i class="fas fa-check-circle action add ml-2" matTooltip="Escolher" (click)="selectServidorPapel()" (keyDown)="selectServidorPapel()"></i>
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearServidorPapel()" (keyDown)="clearServidorPapel()"></i>
        </div>
    }

    <!-- Local do E-Docs fixo -->
    @if ($recipientMode() == RecipientMode.Fixed) {
        <!-- Local do E-Docs -->
        <edocs-location #edocsLocationRef
                        [_model]="$configSchemaSectionEDocsLocation()"
                        [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                        [_isReadOnlyMode]="$isReadOnlyMode()"
                        (_modelChange)="onUpdateEDocsLocation($event)"
        ></edocs-location>

        <div class="form-group ml-6" featureHint="flowObjectDetails|ForwardSelected" featureHintHAlign="right">
            <label for="dispatchRecipientId">Destinatário selecionado</label>
            <input type="text" class="form-control info-font one-button" id="dispatchRecipientId" name="dispatchRecipientId" readonly
                   placeholder="(nenhum)"
                   [ngModel]="$configSchemaSectionEDocsLocation().name"
                   [matTooltip]="$configSchemaSectionEDocsLocation().name"
            >
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearDestinatario()" (keyDown)="clearDestinatario()"></i>
        </div>
    }

    <!-- Local do E-Docs condicional -->
    @if ($recipientMode() == RecipientMode.Conditional) {
        <div class="condition-row ml-3px">
            <!-- Campo do Formulário -->
            <div class="form-group col-5 px-0" featureHint="flowObjectDetails|FormFieldConditional" featureHintHAlign="right">
                <label for="formFieldConditional">Campo do Formulário</label>

                <select class="form-control" id="formFieldConditional" name="formFieldConditional"
                        [ngModel]="$formFieldConditional()"
                        (change)="$formFieldConditional.set($event.target.value)"
                >
                    @for (option of $formFieldConditionalOptions(); track option) {
                        <option [value]="option.value">{{option.description}}</option>
                    }
                </select>
            </div>

            <!-- Operação -->
            <div class="form-group col-3 px-2" featureHint="flowObjectDetails|OperationConditional" featureHintHAlign="right">
                <label for="valueConditional">Operação</label>

                <select class="form-control" id="operationConditional" name="operationConditional"
                        [ngModel]="$isOperationEqualConditional()"
                        (change)="$isOperationEqualConditional.set($event.target.value)"
                >
                    <option [value]="true">IGUAL</option>
                    <option [value]="false">DIFERENTE</option>
                </select>
            </div>

            <!-- Valor do Campo -->
            <div class="form-group col-4 px-0" featureHint="flowObjectDetails|ValueConditional" featureHintHAlign="right">
                <label for="valueConditional">Valor do Campo</label>

                <input type="text" class="form-control" id="valueConditional" name="valueConditional"
                       [ngModel]="$valueConditional()"
                       (change)="$valueConditional.set($event.target.value)"
                />
            </div>
        </div>

        <!-- Local do E-Docs -->
        <edocs-location #edocsLocationConditionalRef
                        [_model]="$configSchemaSectionEDocsLocationConditional()"
                        [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                        [_isReadOnlyMode]="$isReadOnlyMode()"
                        [_isConditionalForwarding]="true"
                        (_modelChange)="onUpdateEDocsLocationConditional($event)"
        ></edocs-location>

        <!-- Painel de condições -->
        <ng-container>
            @if ($configSchema().taskDispatchProcess.conditionalRecipients.length == 0) {
                <div class="conditions-container empty mt-4 mb-3 p-2">
                    <span class="info-font">Nenhuma condição adicionada</span>
                </div>
            } @else {
                <div class="conditions-container mt-4 mb-3 p-2">
                    @for (condition of $configSchema().taskDispatchProcess.conditionalRecipients; track condition; let i = $index) {
                        <div class="condition p-2">
                            <pre class="m-0" [safeHtmlContent]="prettyPrint(condition)"></pre>

                            @if (i > 0) {
                                <i class="fas fa-arrow-up ml-2" matTooltip="Mover condição para cima"
                                   (click)="moveCondition(condition, true)"
                                   (keyDown)="moveCondition(condition, true)"
                                ></i>
                            }

                            @if (i < $configSchema().taskDispatchProcess.conditionalRecipients.length - 1) {
                                <i class="fas fa-arrow-down ml-2" matTooltip="Mover condição para baixo"
                                   (click)="moveCondition(condition)"
                                   (keyDown)="moveCondition(condition)"
                                ></i>
                            }

                            <i class="fas fa-trash-alt ml-2" matTooltip="Remover condição"
                               (click)="removeCondition(condition)"
                               (keyDown)="removeCondition(condition)"
                            ></i>
                        </div>
                    }

                    <button type="button" class="btn btn-outline-danger"
                            [disabled]="$isReadOnlyMode()"
                            (click)="removeAllConditions()"
                            (keyDown)="removeAllConditions()"
                    >
                        <i class="fas fa-times-circle mr-1"></i>
                        <span>Remover todas as condições</span>
                    </button>
                </div>
            }
        </ng-container>
    }

    <div class="form-group mt-4">
        <h6>Mensagem do Despacho</h6>
    </div>

    @if ($isDispatchSummaryBootstrapFinished()) {
        <div class="form-group ml-3px" featureHint="flowObjectDetails|DispatchProcessSummary" featureHintHAlign="right" featureHintVAlign="top">
            <editor name="dispatchSummary" apiKey="no-api-key"
                    [ngModel]="$dispatchSummary()"
                    [init]="tinyMceOptionsProcess"
                    (ngModelChange)="$dispatchSummary.set($event)"
            ></editor>
            <textarea id="tinyMceDispatchProcess" class="d-none"></textarea>
        </div>
    }

    <div class="form-group mt-4">
        <h6>Nível de Acesso do Despacho</h6>
    </div>

    <!-- Nível de Acesso -->
    <access-level #accessLevelRef
                  [_model]="$configSchemaSectionAccessLevel()"
                  [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                  [_isReadOnlyMode]="$isReadOnlyMode()"
                  (_modelChange)="onUpdateAccessLevel($event)"
    ></access-level>
}
